export default __webpack_public_path__ + "static/property-img-9e75a85e10f7485c0e9beca6a3b3d247.png";